import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/system';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import useFavouritesRenameMutation from '../services/useFavouritesRenameMutation';

interface RenameFavouriteDialogProps {
  favouriteId: number;
  isOpen: boolean;
  currentDisplayName: string;
  currentFavouriteName: string;
  onClose: () => void;
}

const RenameTextField = styled(TextField)({
  '& input': {
    height: 15,
    padding: 10
  },
  width: '100%',
  marginTop: 5
});

const RenameFavouriteDialog: FC<RenameFavouriteDialogProps> = ({
  favouriteId,
  isOpen,
  currentDisplayName,
  currentFavouriteName,
  onClose
}) => {
  const { t } = useTranslation();
  const [renamedValue, setRenamedValue] = useState<string>('');
  const { mutateAsync: renameFavourite } = useFavouritesRenameMutation();
  const queryClient = useQueryClient();

  useEffect(() => {
    setRenamedValue(currentDisplayName);
  }, [currentDisplayName]);

  const handleOnSave = async () => {
    await renameFavourite({ favoriteId: favouriteId, displayName: renamedValue });
    queryClient.invalidateQueries(['useFavourites']);
    onClose();
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle variant="h2" sx={{ color: 'primary.main' }}>
        {t('Fav.rename.title')}
      </DialogTitle>
      <DialogContent>
        <Stack direction="row">
          <Typography sx={{ color: 'red', mr: 1 }} variant="body2">
            *
          </Typography>
          <Typography variant="body2">
            {t('Fav.rename.message1')} <b>{currentFavouriteName}</b> {t('Fav.rename.message2')}
          </Typography>
        </Stack>
        <RenameTextField value={renamedValue} onChange={(e) => setRenamedValue(e.target.value)} />
        <Stack direction="row" columnGap={2} mt={2} justifyContent="flex-end">
          <Button size="large" variant="contained" onClick={handleOnSave}>
            {t('Case.button.save')}
          </Button>
          <Button size="large" variant="contained" onClick={onClose}>
            {t('Case.button.cancel')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RenameFavouriteDialog;
